import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getMe } from './api/me';
import { getRefresh } from './api/refresh';
import { resetSession } from './AppAction';

export const initApp = createAsyncThunk(
  'app/initApp',
  async (payload, thunkAPI) => {
    try {
      await getRefresh();
      const me = await getMe();

      if (!!me?.data?.success) {
          return me.data.data;
      }
    } catch (err) {
    }
    return thunkAPI.rejectWithValue("Not logged in.");
  }
);

const initialState = {
  isAppLaunching: true,
  me: null,
  isLoggedIn: null,
};

export const AppSlice = createSlice(
  {
    name: 'app',
    initialState,
    reducers: {},
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
      builder
        .addCase(resetSession, (state, action) => {
          state.me = null;
          state.isLoggedIn = false;
          state.isAppLaunching = false;
        })
        .addCase(initApp.fulfilled, (state, action) => {
          state.me = action.payload;
          state.isLoggedIn = !!action.payload;
          state.isAppLaunching = false;
        })
        .addCase(initApp.rejected, (state, action) => {
          state.me = null;
          state.isLoggedIn = false;
          state.isAppLaunching = false;
        })
    },
  }
);

export default AppSlice;